var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c(_vm.template, {
    tag: "component"
  }, [_c('div', {
    staticClass: "gift"
  }, [_c('div', [_c('div', {
    staticClass: "tit-wrap tit-wrap--unberline"
  }, [_c('h2', {
    staticClass: "tit"
  }, [_vm._v("이벤트 참여내역")])])]), _c('div', {
    staticClass: "mt-4"
  }, [_c('div', [_c('v-data-table', {
    staticClass: "v-data-table--sm",
    attrs: {
      "items": _vm.logs,
      "headers": _vm.logsHeaders,
      "hide-default-footer": "",
      "disable-pagination": "",
      "disable-sort": ""
    },
    scopedSlots: _vm._u([{
      key: "item.isPayment",
      fn: function fn(_ref) {
        var item = _ref.item;
        return _c('span', {}, [_vm._v(_vm._s(item.isPayment === false ? "미지급" : "지급"))]);
      }
    }, {
      key: "item.createdAt",
      fn: function fn(_ref2) {
        var item = _ref2.item;
        return _c('span', {}, [_vm._v(_vm._s(_vm.$dayjs(item.createdAt).format("YYYY-MM-DD HH:mm:ss")))]);
      }
    }])
  }, [_c('span', {
    attrs: {
      "slot": "item.eventname"
    },
    slot: "item.eventname"
  }, [_vm._v("클로버 위크")])])], 1)]), _c('div', {
    staticClass: "mt-30px mt-md-40px"
  }, [_c('v-pagination', {
    attrs: {
      "length": _vm.pageCount,
      "total-visible": "11"
    },
    on: {
      "input": function input($event) {
        return _vm.init();
      }
    },
    model: {
      value: _vm.page,
      callback: function callback($$v) {
        _vm.page = $$v;
      },
      expression: "page"
    }
  })], 1)])]);
}
var staticRenderFns = []

export { render, staticRenderFns }